import { createConsumer } from '@rails/actioncable';

let consumer = null;
let liveAgentSubscription = null;

export const subscribeLiveAgentChannel = (container) => {
  if (liveAgentSubscription) return;

  const personId = container.dataset.personId;
  if (!personId) return;

  if (!consumer) {
    consumer = createConsumer();
  }

  liveAgentSubscription = consumer.subscriptions.create(
    { channel: 'Integrations::OpenAI::Chatkit::RequestLiveAgentChannel', person_id: personId },
    {
      received(data) {
        window.ChatKitWidget.liveAgentRequest = data;
      }
    }
  );
};

export const unsubscribeLiveAgentChannel = () => {
  if (liveAgentSubscription) {
    liveAgentSubscription.unsubscribe();
    liveAgentSubscription = null;
  }
};
